var _rect, _rect2, _mask, _rect3, _rect4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutService2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.943359,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#33B4A0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 20.9434,
    width: 28.8,
    height: 3.2,
    rx: 1.6,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2614_3208",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 55.3438,
    width: 28.8,
    height: 3.2,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 55.3438,
    width: 28.8,
    height: 3.2,
    rx: 1,
    fill: "white",
    stroke: "white",
    strokeWidth: 3.2,
    mask: "url(#path-3-inside-1_2614_3208)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 23.543,
    width: 19.6,
    height: 32.4,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.904 59.9437L32.9144 56.3438H34.6964L32.686 59.9437H30.904Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6966 59.9437L48.6862 56.3438H46.9042L48.9146 59.9437H50.6966Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutService2);
export default __webpack_public_path__ + "static/media/about-service-2.d83380d50ec667c76c943c98315f89d0.svg";
export { ForwardRef as ReactComponent };